export default {
  credentialsContainer: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: 16,
    gap: 16,
  },
  port: {
    maxWidth: 100,
    padding: 8,
    boxSizing: 'border-box',
  },
  inputContainer: {
    flex: 1,
    width: '100%',
    maxWidth: '100%',
    padding: 8,
    boxSizing: 'border-box',
  },
  header: {
    marginBottom: 8,
    fontWeight: 'bold',
  },
  confTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#3d3d3d',
  },
  validateSFTPWithoutErrors: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
    color: 'green',
  },
  validateSFTPWithErrors: {
    display: 'flex',
    gap: 16,
    marginTop: 16,
    marginBottom: 16,
    color: 'red',
  },
  saveButtonContainer: {
    paddingTop: 10,
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 10,
  },
};
